module.exports = __webpack_public_path__ + "ef4509c6d87ad042fbced891c08bd1f7.svg";